import { render } from "./UserSettings.vue?vue&type=template&id=1b8d10c1"
import script from "./UserSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/UserSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b8d10c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b8d10c1', __exports__)) {
    api.reload('1b8d10c1', __exports__)
  }
  
  module.hot.accept("./UserSettings.vue?vue&type=template&id=1b8d10c1", () => {
    api.rerender('1b8d10c1', render)
  })

}


export default __exports__